import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function postUpdateProject(form) {
  if (!form || typeof form !== "object" || !form.id) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid update request." },
        "Invalid update request.",
        "api.project.update.validation.invalidRequest",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/update_project`;

    const res = await authFetch(
      path,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Session expired. Please sign in again." },
          "Session expired. Please sign in again.",
          "api.auth.token.expired",
        ),
      };
    }

    const data = await res.json().catch(() => null);
    if (!data) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
          "api.common.serverError",
        ),
      };
    }

    if (!res.ok || data?.success !== true) {
      const fallbackKey =
        res.status === 404
          ? "api.project.update.notFound"
          : res.status === 400
            ? "api.project.update.validation.invalidRequest"
            : "api.project.update.failed";

      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          data,
          "Update failed.",
          fallbackKey,
        ),
      };
    }

    return {
      success: true,
      ...normalizeApiMessageWithFallbackKey(
        data,
        "Updated successfully.",
        "api.project.update.success",
      ),
    };
  } catch (error) {
    console.error("postUpdateProject request failed:", error);
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Server request failed." },
        "Server request failed.",
        "api.common.networkError",
      ),
    };
  }
}
